import { ajaxFunc } from '../tools';
const exchangeCenter = {
    /****换货活动****/
    //换货规则
    getExchangeActivityDetail: ajaxFunc('/tb/cloudStorage/getExchangeActivityDetail', 'get'),
}

export default exchangeCenter;



// WEBPACK FOOTER //
// ./src/request/api/exchangeCenter.js